import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg sm:rounded-lg px-6 py-10 bg-white w-4/6 ml-20" }
const _hoisted_2 = { class: "flex justify-center mb-4" }
const _hoisted_3 = { class: "mb-4 sm:mb-0 items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex justify-center mb-4" }
const _hoisted_6 = { class: "mb-4 sm:mb-0 items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pl-8" }
const _hoisted_9 = { href: "https://admin-ba.superprati.co/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PerfilMainView = _resolveComponent("PerfilMainView")!

  return (_openBlock(), _createBlock(_component_PerfilMainView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "items-center",
              src: _ctx.logoPilotar,
              alt: "Pilotar"
            }, null, 8, _hoisted_4)
          ])
        ]),
        _createElementVNode("header", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              class: "items-center",
              src: _ctx.loginFolder,
              alt: "loginFolder"
            }, null, 8, _hoisted_7)
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-row justify-center ml-5" }, [
          _createElementVNode("h1", { class: "text-lg text-center mt-5 px-1" }, "Para utilizar os serviços Pilotar, realize o"),
          _createElementVNode("h1", { class: "text-lg text-center px-1" }, "login no SuperPrático.")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_Button, {
              color: "primary",
              class: "h-12 w-45 text-white mr-9 mt-5"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Fazer login ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}